import { DEFAULT_SPORTS, DEFAULT_TYPES } from '../../../sports'

const _giftcodeBenefit = {
  type: 'object',
  properties: {
    type: {
      type: 'string',
      title: 'Etutyyppi',
      anyOf: [
        {
          type: 'string',
          title: 'Prosentuaalinen alennus (aina)',
          enum: ['pricereduction'],
        },
        {
          type: 'string',
          title: 'Etuhinta (aina)',
          enum: ['price'],
        },
        {
          type: 'string',
          title: 'Ilmaiskoodi',
          enum: ['free'],
        },
        {
          type: 'string',
          title: 'Alennushinnasto',
          enum: ['pricing'],
        },
        {
          type: 'string',
          title: 'Osan maksu (€)',
          enum: ['partpaymentmoney'],
        },
        {
          type: 'string',
          title: 'Osan maksu (%)',
          enum: ['partpaymentpercent'],
        },
      ],
    },
  },
  dependencies: {
    type: {
      oneOf: [
        {
          properties: {
            type: {
              enum: ['pricereduction'],
            },
            value: {
              type: 'number',
              title: 'Montako prosenttia alennus',
            },
          },
        },
        {
          properties: {
            type: {
              enum: ['price'],
            },
            value: {
              type: 'number',
              title: 'Mikä on etuhinta',
            },
          },
        },

        {
          properties: {
            type: {
              enum: ['free'],
            },
          },
        },
        {
          properties: {
            type: {
              enum: ['pricing'],
            },
            value: {
              title: 'Hinnoittelu (kenttävaraus)',
              type: 'string',
              oneOf: [],
            },
          },
        },
        {
          properties: {
            type: {
              enum: ['partpaymentmoney'],
            },
            value: {
              type: 'number',
              title: 'Paljonko vuorosta jää laskulle (€)',
            },
          },
        },
        {
          properties: {
            type: {
              enum: ['partpaymentpercent'],
            },
            value: {
              type: 'number',
              title: 'Paljonko vuorosta jää laskulle (%)',
            },
          },
        },
      ],
    },
  },
}

export const _giftcodeClass = {
  name: { type: 'string', title: 'Etukoodin nimi' },
  code: { type: 'string', title: 'Koodi' },
  start: {
    type: 'string',
    format: 'date',
    title: 'Alkaa',
  },
  end: {
    type: 'string',
    format: 'date',
    title: 'Loppuu',
  },
  onepercustomer: {
    type: 'boolean',
    title: 'Yksi per asiakas',
  },
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'active', title: 'Aktiivinen' },
      { const: 'paused', title: 'Pysäytetty' },
    ],
  },
  type: {
    type: 'string',
    title: 'Tyyppi',
    oneOf: [
      { const: 'courtreservation', title: 'Kenttävaraus' },
      { const: 'activity', title: 'Aktiviteetti' },
    ],
  },
  benefit: {
    title: '',
    description: 'Etu',
    type: 'array',
    items: _giftcodeBenefit,
  },
  quota: {
    type: 'object',
    title: 'Määrärajat',
    properties: {
      left: {
        type: 'number',
        title: 'Jäljellä',
        readOnly: false,
        default: 100
      },
      total: {
        type: 'number',
        title: 'Kokonaismäärä',
        default: 100,
      }
    }
  }

}

export const _giftcodeClassDeps = {
  type: {
    oneOf: [
      {
        properties: {
          type: {
            enum: ['courtreservation'],
          },
          reservationduration: {
            type: 'number',
            title: 'Vuoron pituus (minuuttia)',
            description: 'Koodilla voi varata vain tämän pituisen vuoron. Tyhjä = ei rajoitusta.',
          },
        },
      },
      {
        properties: {
          type: {
            enum: ['activity'],
          },
          sport: {
            type: 'string',
            title: 'Laji',
            oneOf: DEFAULT_SPORTS.map(sport => ({ const: sport.label, title: sport.label })),
          },
          activitytype: {
            type: 'string',
            title: 'Aktiviteetin tyyppi',
            oneOf: DEFAULT_TYPES.map(type => ({ const: type.label, title: type.label })),
          },
          providertype: {
            type: 'string',
            title: 'Tapahtuman sisäinentyyppi',
          },
        },
      },
    ],
  },
}

export const _giftcodeUISchema = {}